export default "__VITE_ASSET__DEF$b42j__"